import { articleTitleToSlug } from 'src/utils/article-slug';
import { skillNameToSlug } from 'src/utils/skill-slug';

// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  ORGANIZATION_DASHBOARD: '/organization-dashboard',
  SKILLS: '/skills',
  SETTING: '/setting',
  USER: '/user',
  ADMIN: '/admin',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
      resetPassword: (accessToken: string) => `${ROOTS.AUTH}/jwt/set-password/${accessToken}`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgot-password`,
      registrationEmailVerification: (token: string) =>
        `${ROOTS.AUTH}/jwt/verify-email?token=${token}`,
    },
  },
  admin: {
    root: `${ROOTS.ADMIN}/organizations`,
    organizations: `${ROOTS.ADMIN}/organizations`,
    superAdmins: `${ROOTS.ADMIN}/super-admins`,
    jobRoles: `${ROOTS.ADMIN}/job-roles`,
    // skillBuilder: '/admin/skill-builder',
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
  },
  organizationDashboard: {
    root: ROOTS.ORGANIZATION_DASHBOARD,
  },
  skills: {
    root: ROOTS.SKILLS,
    viewSkill: (skillId: string, skillName: string) =>
      `${ROOTS.SKILLS}/${skillId}/${skillNameToSlug(skillName)}`,
  },
  setting: {
    root: ROOTS.SETTING,
    // organization: `${ROOTS.SETTING}/organization`,
  },
  user: {
    root: `${ROOTS.USER}`,
    profile: `${ROOTS.USER}/profile`,
    performance: (userId: string) => `${ROOTS.USER}/${userId}/performance`,
  },
  articles: {
    root: '/articles',
    view: (articleId: string, title: string) =>
      `/articles/${articleId}/${articleTitleToSlug(title)}`,
  },
  analytics: {
    root: '/analytics',
  },
  notifications: {
    root: '/notifications',
  },
  skillBuilder: {
    root: '/skill-builder',
    topics: (skillId: string, skillName: string) =>
      `/skill-builder/${skillId}/${skillNameToSlug(skillName)}`,
  },
  about: '/about',
  contact: '/contact-us',
  faqs: '/faq',
  figma: '/',
  components: '/',
  pricing: '/pricing',
};
